import { makeAutoObservable, runInAction } from 'mobx'
import agent, { WishlistItemDto } from '../api/agent'

export default class WishlistStore {
  items: WishlistItemDto[] = []
  loading = false

  constructor () {
    makeAutoObservable(this)
  }

  isInWishlist = (firearmModelId: string) =>
    this.items.some((i) => i.firearmModelId === firearmModelId)

  getItem = (firearmModelId: string) =>
    this.items.find((i) => i.firearmModelId === firearmModelId)

  loadWishlist = async () => {
    this.loading = true
    try {
      const data = await agent.Wishlist.list()
      runInAction(() => {
        this.items = data
        this.loading = false
      })
    } catch {
      runInAction(() => (this.loading = false))
    }
  }

  addToWishlist = async (firearmModelId: string, notes?: string) => {
    this.loading = true
    try {
      const entry = await agent.Wishlist.add(firearmModelId, notes)
      runInAction(() => {
        this.items = [entry, ...this.items]
        this.loading = false
      })
      return entry
    } catch (error) {
      runInAction(() => (this.loading = false))
      throw error
    }
  }

  updateItem = async (id: string, body: { isPublic?: boolean; notes?: string | null }) => {
    try {
      const updated = await agent.Wishlist.patch(id, body)
      runInAction(() => {
        const idx = this.items.findIndex((x) => x.id === id)
        if (idx >= 0) this.items[idx] = updated
      })
      return updated
    } catch (error) {
      console.error(error)
      throw error
    }
  }

  removeFromWishlist = async (id: string) => {
    this.loading = true
    try {
      await agent.Wishlist.remove(id)
      runInAction(() => {
        this.items = this.items.filter((i) => i.id !== id)
        this.loading = false
      })
    } catch (error) {
      runInAction(() => (this.loading = false))
      throw error
    }
  }
}
